<template>
  <div class="bussiness_total" >
    <el-divider content-position="left">续费统计表</el-divider>
    <el-row>
      <el-col :span="5" style="float: right">
        <el-date-picker
          v-model="yearTimer"
          type="year"
          size="mini"
          value-format="yyyy"
          @change="pickerDataChange"
          placeholder="请选择时间">
        </el-date-picker>
      </el-col>
    </el-row>
    <el-table :data="totalData" size="medium" show-summary style="width: 100%; margin-top: .2rem;" v-cloak>
      <el-table-column label="月份" prop="month"></el-table-column>
      <el-table-column label="新增企业数量(家)" prop="new_count"></el-table-column>
      <el-table-column label="续费企业数量(家)" prop="renew"></el-table-column>
      <el-table-column label="企业交接出去(家)" prop="destory"></el-table-column>
      <el-table-column label="企业注销(家)" prop="out_company"></el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'bussiness_total',
  data () {
    return {

      totalData: [],
      yearTimer: ''
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  watch: {},
  methods: {
    pickerDataChange (val) {
      if (!val) {
        this.yearTimer = ''
      } else {
        this.yearTimer = val
      }
      this.handelGetTotalData()
    },
    handelGetTotalData () {
      this.$axios.get('/api/finance/get_total?timer=' + this.yearTimer)
        .then((res) => {
          const {data} = res
          if (data.code === 0) {
            this.totalData = data.data.list
          }
        })
    }
  },
  mounted () {
    this.handelGetTotalData()
  }
}
</script>
<style scoped lang="stylus">
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  @import '~styles/icon.styl'
  [v-cloak]
    display: none
  .el-drawer__wrapper >>> .el-drawer
    overflow-y: auto
  .el-collapse
    border-bottom 0
    border-top 0
  .el-collapse >>> .el-collapse-item__header
    color: #4C87FC
    font-weight bold
  .el-collapse >>> .el-collapse-item__arrow
    color: #4C87FC
  .el-select
    width: 100%
  .bussiness_total >>> .el-table__header th
    color: #333333
    background-color: #ECF4FF
  .bussiness_total
    marginLeft()
    .count_style
      display: inherit
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
  .search-row .el-col
    margin-bottom: .2rem
  .tr
    text-align: right
  .mt-10
    margin-top: .2rem
  .m-tabs-content
    padding: 0 .2rem 0 .4rem
    .m-label
      line-height: .64rem
    .el-row
      margin-bottom: .4rem
  .el-date-editor
    width: 100%
</style>



// WEBPACK FOOTER //
// src/pages/bussiness_total/bussiness_total.vue